import * as d3 from "d3";

export const variables = {
  solidarity_pct: {
    breaks: [0.8, 1, 1.1, 1.2, 1.25, 1.3, 1.45],
    mapbox: ["/", ["get", "nombre_aides"], ["get", "n_small_hosp_ent"]],
    scale: "%",
    multiplier: 100.0,
    display: "% of small hospitality establishments with solidarity grant",
    js: (v) => v.nombre_aides / v.n_small_hosp_ent,
    description: "The number of solidarity grants awarded to the hospitality and food service industry divided by the number of qualifying hospitality and food service establishment registrations in a department. "
  },

  solidarity_iz: {
    breaks: [400, 500, 600, 700, 900, 1100, 2000],
    mapbox: ["/", ["get", "montant_total"], ["get", "all_iz"]],
    scale: " €",
    multiplier: 1.0,
    display: "Hospitality solidarity grant per hospitality sector worker",
    js: (v) => v.montant_total / v.all_iz,
    description: "The total solidarity grant awarded to all hospitality and food service businesses in a department, divided by the number of hospitality and food service  workers in that department."
  },

  solidarity_percap: {
    breaks: [40, 50, 60, 70, 90, 110, 200],
    mapbox: ["/", ["get", "tot_montant_total"], ["get", "totpop"]],
    scale: " €",
    multiplier: 1.0,
    display: "Solidarity grant per capita (all sectors)",
    js: (v) => v.tot_montant_total / v.totpop,
    description: "The total solidarity grant awarded to all businesses in a department, divided by the population of that department."
  },

  furlough_pct: {
    breaks: [0.18, 0.23, 0.28, 0.32, 0.35, 0.4, 0.46],
    mapbox: [
      "/",
      ["get", "nombre_etablissements_concernes"],
      ["get", "n_hosp_ent"],
    ],
    scale: "%",
    multiplier: 100.0,
    display: "% of hospitality establishments utilizing Chômage partiel",
    js: (v) => v.nombre_etablissements_concernes / v.n_hosp_ent,
    description:
      "The number of hospitality and food service establishments that have recieved support from the Chômage partiel program, divided by the number of hospitality and food service establishments in a department.",
  },

  furlough_emps_iz: {
    breaks: [0.6, 0.7, 0.8, 0.85, 0.9, 0.95, 1.0],
    mapbox: [
      "/",
      ["get", "nombre_salaries_concernes"],
      ["get", "all_iz"],
    ],
    scale: "%",
    multiplier: 100.0,
    display: "% of hospitality employees utilizing Chômage partiel",
    js: (v) => v.nombre_salaries_concernes / v.all_iz,
    description: "The number of hospitality and food service employees recieving Chômage partiel aid divided by the total number of workers in that sector in the department."
  },


  furlough_emps: {
    breaks: [0.29, 0.4, 0.43, 0.46, 0.48, 0.55, 1.0],
    mapbox: [
      "/",
      ["get", "tot_nombre_salaries_concernes"],
      ["get", "tot_employment"],
    ],
    scale: "%",
    multiplier: 100.0,
    display: "% of employees utilizing Chômage partiel (all sectors)",
    js: (v) => v.tot_nombre_salaries_concernes / v.tot_employment,
    description: "The number of employees recieving Chômage partiel aid divided by the total number of employees in a department, across all types of businesses."
  },

  income: {
    breaks: [12, 13, 14, 15, 16, 17, 28],
    mapbox: ["/", ["get", "tot_household_income"], ["get", "totpop"]],
    multiplier: 1000,
    scale: " €",
    display: "Per capita income",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.tot_household_income / v.totpop,
    description: "Per capita average income"
  },

  part_time: {
    breaks: [0.12, 0.14, 0.16, 0.18, 0.2, 0.22, 0.24],
    mapbox: ["/", ["get", "PART_TIME"], ["get", "tot_employment"]],
    multiplier: 100,
    scale: "%",
    display: "% part time",
    js: (v) => v.PART_TIME / v.tot_employment,
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    description: "The percentage of the workforce that is employed part time."
  },

  salaried: {
    breaks: [0.08, 0.1, 0.12, 0.14, 0.17, 0.2, 0.25]
      .map((v) => 1 - v)
      .reverse(),
    mapbox: ["/", ["get", "sal_emp"], ["get", "all_emp"]],
    multiplier: 100,
    scale: "%",
    display: "% salaried (total)",
    js: (v) => v.sal_emp / v.all_emp,
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    description: "The percentage of the workforce that is salaried."
  },

  salaried_hosp: {
    breaks: [0.08, 0.12, 0.16, 0.2, 0.25, 0.3, 0.4].map((v) => 1 - v).reverse(),
    mapbox: ["/", ["get", "sal_iz"], ["get", "all_iz"]],
    multiplier: 100,
    scale: "%",
    display: "% salaried (hospitality)",
    js: (v) => v.sal_iz / v.all_iz,
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    description: "The percentage of the workforce in the hospitality sector that is salaried."
  },

  pct_immigrants: {
    breaks: [0.02, 0.04, 0.06, 0.08, 0.1, 0.12, 0.3],
    mapbox: ["get", "pct_immigrants"],
    multiplier: 100,
    scale: "%",
    display: "% immigrants",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.pct_immigrants,
    description: "The percentage of the population that has immigranted to France."
  },

  pct_grad: {
    breaks: [19, 32, 35, 38, 41, 44, 77],
    mapbox: ["get", "young_graduates"],
    multiplier: 1,
    scale: "%",
    display: "% young people with degree",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.young_graduates,
  },

  pct_employment_2016: {
    breaks: [0.57, 0.6, 0.62, 0.64, 0.66, 0.68, 0.71],
    mapbox: ["/", ["get", "tot_employment"], ["get", "pop5to64"]],
    multiplier: 100,
    scale: "%",
    display: "% employment",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.tot_employment / v.pop5to64,
    description: "The percentage of the population age 15-64 that is employed."
  },

  density: {
    breaks: [20, 40, 70, 120, 400, 800, 20000],
    mapbox: ["/", ["get", "totpop"], ["get", "area"]],
    scale: " people per square km",
    multiplier: 1,
    display: "Population density",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.totpop / v.area,
  },
};

export const interactiveVariables = [
  ["Chômage partiel", "Solidarity grants", "Demographic data"],
  ["furlough_pct", "furlough_emps"],
  ["solidarity_pct", "solidarity_iz", "solidarity_percap"],
  [
    "income",
    "pct_immigrants",
    "pct_employment_2016",
    "part_time",
    "salaried",
    "salaried_hosp",
    "density",
  ],
];
